import React from 'react'
import { FormCheckbox, FormDate, FormInput } from '@myxplor/forms'
import Attachment from './attachment'
import { NewWindowIcon } from '../../../ui/gov-messages'

const addFile = (event, values, onChange) => {
  const file = event.target.files[0]

  if (file) {
    const reader = new FileReader()

    reader.onload = (readerEvent) => {
      const binaryString = btoa(readerEvent.target.result)
      const blob = {
        content: `${binaryString}`,
        type: 'ACC005',
        name: file.name,
        size: file.size,
        mime: file.type
      }

      onChange('evidence', [...values.evidence, blob])
    }

    reader.readAsBinaryString(file)
  }
}

const NoLongerAtRiskForm = (props) => {
  const { values, onChange } = props
  return (
    <fieldset>
      <legend>Child no longer at risk</legend>
      <FormDate
        label='Date no longer at risk'
        name='date_no_longer_risk'
        value={values.date_no_longer_risk}
        onChange={onChange}
        required={true}
        today
      />
      <FormInput
        required
        label='No longer at risk reason'
        name='risk_reason'
        value={values.risk_reason}
        type='text'
        autoFocus={false}
        onChange={onChange}
      />
      <div id='evidenceHeader'>
        <div>
          <strong>Attach Evidence</strong>
          <br />
          Government file limit: 5.4mb. PDF, PNG, JPG, TIFF only.
        </div>
        <div>
          <input
            type='file'
            id='file'
            onChange={(event) => addFile(event, values, onChange)}
            accept='.jpg, .png, .pdf, tiff'
          />
          <label htmlFor='file'>
            Attach
            <NewWindowIcon />
          </label>
        </div>
      </div>
      {values.evidence && values.evidence.map((_, idx) => {
        return <Attachment key={idx} idx={idx} {...props} hasType={true} />
      })}
      <FormCheckbox
        required
        label='Do you have record to support that child is no longer at risk'
        name='record_support_risk'
        value={values.record_support_risk}
        onChange={onChange}
        compact
      />
      <FormCheckbox
        required
        label='I confirm that the information provided is true and correct'
        name='declaration_given'
        value={values.declaration_given}
        onChange={onChange}
        compact
      />
      By advising the government the child is no longer at risk, they will stop
      receiving additional subsidy. Do you wish to continue?
    </fieldset>
  )
}

export default NoLongerAtRiskForm



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/no-longer-at-risk.js